<template>
	<div class="barcode_inst_container">
		<header-component
			:is-soon="false"
			:next="'/chip'"
			img-left="/trocachip/img/fechar.svg"
			img-right="/trocachip/img/access.png"
			class="header-component"
		/>

		<span class="barcode_inst_title"
			>Veja como incluir as informações do seu chip e finalize a ativação</span
		>
		<slick-carousel
			ref="carousel"
			v-bind="carouselSettings"
			@afterChange="trackEvent"
			@init="trackInit"
		>
			<div
				v-for="(info, index) in pageMessages"
				:key="index"
				class="barcode_inst_infos"
			>
				<img :src="getImageSrc(info.image)" />
				<span v-html="info.text" class="barcode_inst_info_text"></span>
			</div>
		</slick-carousel>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import HeaderComponent from '../components/HeaderComponent.vue';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { mapState } from 'vuex';
import trackEvent from '../services/trackEvent';

export default {
	name: 'BarcodeInstructions',
	components: {
		'slick-carousel': VueSlickCarousel,
		'header-component': HeaderComponent,
	},
	computed: mapState({
		config: (state) => state.config,
		customer: (state) => state.customer,
	}),
	data() {
		return {
			pageMessages: [],
			carouselSettings: {
				arrows: false,
				autoplay: false,
				dots: true,
				draggable: false,
				infinite: false,
				swipe: true,
			},
		};
	},
	created() {
		this.pageMessages = this.config.barcode_instructions;
	},
	methods: {
		getImageSrc(imageName) {
			return require('../assets/images/' + imageName);
		},
		trackInit() {
			this.trackBarCodeEvents('Troca de Chip Informacao Embalagem');
		},
		trackEvent(slideIndex) {
			console.log(slideIndex);
			if (slideIndex == 0) {
				this.trackBarCodeEvents('Troca de Chip Informacao Embalagem');
			} else if (slideIndex == 1) {
				this.trackBarCodeEvents('Troca de Chip Dica Codigo De Barras');
			}
		},
		trackBarCodeEvents(label) {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: {
					name: '7',
				},
				'event-category': 6,
				'event-action': 3,
				'event-label': label,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': '',
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.barcode_inst_container {
	display: flex;
	flex-direction: column;
	height: 100vh;
	justify-content: center;
	.barcode_inst_title {
		font-family: 'timsans_regular';
		font-size: 27px;
		text-align: center;
		margin: 30px 0;
	}
	.barcode_inst_infos {
		width: 100% !important;
		display: flex !important;
		flex-direction: column;
		align-items: center;
		> span {
			text-align: center;
			font-family: 'timsans_regular';
			max-width: 70%;
			opacity: 0.6;
			margin: 20px 0;
		}
	}
}
</style>
